import classNames from "classnames";
import { BasicProps } from "./ComponentsInterface";

export const LColumns = ({ ...props }: BasicProps): JSX.Element => {
    const classes = classNames("columns", props.className);

    return <div className={classes}>{props.children}</div>;
};

export const LColumn = ({ ...props }: LColumnProps): JSX.Element => {
    const classes = classNames("column", `is-${props.size}`, props.className);

    return <div className={classes}>{props.children}</div>;
};

interface LColumnProps extends BasicProps {
    size?: string;
}
